import { render, staticRenderFns } from "./RoomsSection.vue?vue&type=template&id=ace587bc&scoped=true"
import script from "./RoomsSection.vue?vue&type=script&lang=js"
export * from "./RoomsSection.vue?vue&type=script&lang=js"
import style0 from "./RoomsSection.vue?vue&type=style&index=0&id=ace587bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace587bc",
  null
  
)

export default component.exports